import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import{ GlobalProvider } from '../../providers/global/global';

@Component({
  selector: 'logo',
  templateUrl: 'logo.html'
})
export class LogoComponent {

  text: string;
  url: string;
  imgSrc: string;
  logoName: string;
  modifiedURL: string;
  name: string = localStorage.getItem('name');
  splitted: string;
  portal: string;

  //agency_arr: any;
  logoWidth: string;
  logoHeight: string;
  logoID: string;

  constructor(@Inject(DOCUMENT) private document: Document, public global: GlobalProvider) {

    this.setLogo();

  }

  setLogo(){


    this.url = this.document.location.href;

    this.portal = this.global.getPortalID();

    for ( var i = 0; i < this.global.agency_arr.length; i++ ) {
      if (this.portal.includes(this.global.agency_arr[i].agencyName)  ) {

        this.logoWidth = this.global.agency_arr[i].width;
        this.logoHeight = this.global.agency_arr[i].height;
        this.logoID = this.global.agency_arr[i].agencyID;
        break;
      }
    }
    this.imgSrc = '/assets/imgs/' + this.logoID + '.png';

  }

 
}



// WEBPACK FOOTER //
// ./src/components/logo/logo.ts